<div class="help-modal">
  <h1 tabindex="1">{{ title }}</h1>    <button mat-stroked-button (click)="close()">
    Close
  </button>
 
  <div [innerHtml]="$safeNavigationMigration(currentHelp?.content)"></div>
  <div [innerHtml]="$safeNavigationMigration(general?.content)"></div>
    
  <footer>
    <button mat-stroked-button (click)="close()">
      Close
    </button>
  </footer>
</div>
